import CoordiApatmentList from "../../features/coordinator/CoordiApatmentList"

const CoodiApartmentListPage = () => {
    return <CoordiApatmentList />
}

export default CoodiApartmentListPage